var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPrimaryInfo = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M8 1a7 7 0 1 0 .001 14.001A7 7 0 0 0 8 1Zm.5 10.375a.125.125 0 0 1-.125.125h-.75a.125.125 0 0 1-.125-.125v-4.25c0-.069.056-.125.125-.125h.75c.069 0 .125.056.125.125v4.25ZM8 6a.75.75 0 0 1 0-1.5A.75.75 0 0 1 8 6Z", fill: "#CC9E6C" }));
export { SvgPrimaryInfo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTggMWE3IDcgMCAxIDAgLjAwMSAxNC4wMDFBNyA3IDAgMCAwIDggMVptLjUgMTAuMzc1YS4xMjUuMTI1IDAgMCAxLS4xMjUuMTI1aC0uNzVhLjEyNS4xMjUgMCAwIDEtLjEyNS0uMTI1di00LjI1YzAtLjA2OS4wNTYtLjEyNS4xMjUtLjEyNWguNzVjLjA2OSAwIC4xMjUuMDU2LjEyNS4xMjV2NC4yNVpNOCA2YS43NS43NSAwIDAgMSAwLTEuNUEuNzUuNzUgMCAwIDEgOCA2WiIgZmlsbD0iI0NDOUU2QyIvPjwvc3ZnPg==";
